import { defineStore } from 'pinia';
import {
    TextAnimateToStateparams,
    TEXTMODULE_POSSIBLE_STATES,
    TEXTMODULE_TARGET_STATES,
    textModulStateBackTarget
} from "@km/components/text/ModuleTextAnimations";
import { CLOSED } from "@km/animations/animationFactory";

export const useModuleTextOpenStatusStore = defineStore('useModuleTextOpenStatusStore', {
    state: () => ({
        currentState: TEXTMODULE_POSSIBLE_STATES.closed,
        componentTargetStates: {
            textverwaltung: CLOSED,
            edit: CLOSED,
            action_edit: CLOSED,
            typeface: CLOSED,
            color: CLOSED,
            colorShade: CLOSED,
            colorOutline: CLOSED,
            outlineShade: CLOSED,
            textlist: CLOSED
        } as TextAnimateToStateparams
    }),

    getters: {
        getCurrentState: (state) => state.currentState,
        getTextverwaltungState: (state) => state.componentTargetStates.textverwaltung,
        getEditState: (state) => state.componentTargetStates.edit,
        getAction_editState: (state) => state.componentTargetStates.action_edit,
        getTypefaceState: (state) => state.componentTargetStates.typeface,
        getColorState: (state) => state.componentTargetStates.color,
        getColorShadeState: (state) => state.componentTargetStates.colorShade,
        getColorOutlineState: (state) => state.componentTargetStates.colorOutline,
        getOutlineShadeState: (state) => state.componentTargetStates.outlineShade,
        gettextlistState: (state) => state.componentTargetStates.textlist,
    },

    actions: {
        setCurrentState(newstate: TEXTMODULE_POSSIBLE_STATES) {
            const targetState = TEXTMODULE_TARGET_STATES[newstate];
            this.componentTargetStates.textverwaltung = targetState.textverwaltung;
            this.componentTargetStates.edit = targetState.edit;
            this.componentTargetStates.action_edit = targetState.action_edit;
            this.componentTargetStates.typeface = targetState.typeface;
            this.componentTargetStates.color = targetState.color;
            this.componentTargetStates.colorShade = targetState.colorShade;
            this.componentTargetStates.colorOutline = targetState.colorOutline;
            this.componentTargetStates.outlineShade = targetState.outlineShade;
            this.componentTargetStates.textlist = targetState.textlist;
            this.currentState = newstate;
        },

        goUpOneLevel() {
            this.setCurrentState(textModulStateBackTarget[this.currentState]);
        },

        ensureStateIsNotClosed() {
            if (this.currentState === TEXTMODULE_POSSIBLE_STATES.closed) {
                this.setCurrentState(TEXTMODULE_POSSIBLE_STATES.textverwaltung);
            }
        },

        close() {
            this.setCurrentState(TEXTMODULE_POSSIBLE_STATES.closed);
        }
    }
});
